import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { IconMoon, IconSun } from '@tabler/icons-react';

export const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            // Nota: en móvil el header fijo del Sidebar (h-16, z alto) ocupa
            // todo el ancho superior; si el botón se queda en top-4 con un
            // z-index bajo, queda tapado y es inaccesible. Se baja por debajo
            // del header en móvil y se sube el z-index por encima de él.
            className="fixed top-20 right-4 md:top-4 md:right-4 z-[var(--z-floating-control)] p-3 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors shadow-lg"
            aria-label="Toggle theme"
        >
            {theme === 'light'
                ? (
                    <IconMoon size={24} className="text-gray-800" />
                )
                : (
                    <IconSun size={24} className="text-yellow-400" />
                )}
        </button>
    );
};
